"use strict";

module.exports = function getReverseSequenceString(sequence) {
  var reverseSequenceString = "";
  for (var i = sequence.length - 1; i >= 0; i--) {
    var revChar = sequence[i];
    if (!revChar) {
      revChar = sequence[i];
      // throw new Error('trying to get the reverse of an invalid base');
    }
    reverseSequenceString += revChar;
  }
  return reverseSequenceString;
};